import IDrmModifiers                from '../Interfaces/IDrmModifiers';
import ILicenseRequest              from '../Interfaces/ILicenseRequest';
import ILicenseResponse             from '../Interfaces/ILicenseResponse';
import arrayBufferToBase64          from '../Util/arrayBufferToBase64';
import arrayBufferToString          from '../Util/arrayBufferToString';
import base64ToUint8Array           from '../Util/base64ToUint8Array';
import extractMpxTokenFromAuthToken from '../Util/extractMpxTokenFromAuthToken';

const transformLicenseRequest = (releasePid: string, request: ILicenseRequest, authToken: string): void => {
    if (!(request.body instanceof ArrayBuffer)) return;

    request.uris[0] = `${request.uris[0]}&token=${extractMpxTokenFromAuthToken(authToken)}`
        .replace('/getWidevineLicense', '');

    request.body = JSON.stringify({
        getWidevineLicense: {
            releasePid,
            widevineChallenge: decodeURIComponent(arrayBufferToBase64(request.body as ArrayBuffer))
        }
    });
};

const transformLicenseResponse = (response: ILicenseResponse) => {
    if (response.data instanceof Uint8Array) return;

    const {getWidevineLicenseResponse: {license}} = JSON.parse(arrayBufferToString(response.data as ArrayBuffer));

    response.data = base64ToUint8Array(license);
};

const createShakaWidevineDrmModifiers = (
    licenseRequestType: number,
    releasePid: string,
    authToken: string,
    injectedTransformLicenseRequest = transformLicenseRequest,
    injectedTransformLicenseResponse = transformLicenseResponse
): IDrmModifiers => ({
    licenseRequest: (requestType, request) => {
        if (requestType === licenseRequestType) injectedTransformLicenseRequest(releasePid, request, authToken);
    },
    licenseResponse: (requestType, response) => {
        if (requestType === licenseRequestType) injectedTransformLicenseResponse(response);
    }
});

export {
    createShakaWidevineDrmModifiers,
    transformLicenseRequest,
    transformLicenseResponse
};